module.exports = __webpack_public_path__ + "brand-icons.579cad8471395197d60c.eot";


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/fonts/brand-icons/brand-icons.eot?v=0.3.2
// module id = ../../../../../src/fonts/brand-icons/brand-icons.eot?v=0.3.2
// module chunks = styles